import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  divider: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    marginBottom: theme.spacing(3),
  },
  sectionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflow: 'visible',
  },
  sectionAccordion: {
    margin: 0,
    padding: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    '&::before': {
      display: 'none',
    },
  },
  sectionSummary: {
    padding: 0,
    minHeight: 'unset',
    width: '100%',
    '& .MuiAccordionSummary-content': {
      margin: 0,
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      flexShrink: 0,
      marginLeft: theme.spacing(1),
    },
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
    lineHeight: theme.typography.pxToRem(24),
    color: theme.palette.labraText.tertiary,
    textAlign: 'left',
    width: '100%',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  sectionDetails: {
    padding: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  nestedFaqAccordion: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(0.5),
    overflow: 'visible',
    '& [data-testid="accordion-component"]': {
      width: '100%',
      maxWidth: '100%',
    },
    '& [data-testid="accordion-component"] > div': {
      maxHeight: 'none',
      overflowY: 'visible',
      overflow: 'visible',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
        width: 0,
        height: 0,
      },
    },
    '& [data-testid="accordion-menu"]': {
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& .MuiAccordionSummary-root': {
      width: '100%',
      maxWidth: '100%',
      padding: 0,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      flexShrink: 0,
      marginLeft: theme.spacing(1),
    },
    '& [data-testid="accordion-heading"]': {
      width: '100%',
      maxWidth: '100%',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
    },
    '& [data-testid="accordion-description"]': {
      width: '100%',
      maxWidth: '100%',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
    },
    '& .faqQuestionV3': {
      width: '100%',
      maxWidth: '100%',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
    },
  },
  chevron: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.labraText.tertiary,
  },
}))
